export const SET_USERS = 'SET_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const SET_USERS_LIST_OPTIONS = 'SET_USERS_LIST_OPTIONS';
export const SET_SCAN_DATA = 'SET_SCAN_DATA';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_SCAN_DATA_LIST_OPTIONS = 'SET_SCAN_DATA_LIST_OPTIONS';
export const CLEAR_SCAN_DATA = 'CLEAR_SCAN_DATA';
export const SET_WORKERS = 'SET_WORKERS';
export const CLEAR_WORKERS = 'CLEAR_WORKERS';
export const SET_WORKERS_LIST_OPTIONS = 'SET_WORKERS_LIST_OPTIONS';
export const SET_WORKER_DETAILS = 'SET_WORKER_DETAILS';
export const CLEAR_WORKER_DETAILS = 'CLEAR_WORKER_DETAILS';
export const SET_DOMAINS = 'SET_DOMAINS';
export const CLEAR_DOMAINS = 'CLEAR_DOMAINS';
export const SET_DOMAINS_LIST_OPTIONS = 'SET_DOMAINS_LIST_OPTIONS';
export const SET_DISABLE_DELETE_USER_BUTTON = 'SET_DISABLE_DELETE_USER_BUTTON';
export const SET_NEEDED_ACTIONS = 'SET_NEEDED_ACTIONS';
export const CLEAR_NEEDED_ACTIONS = 'CLEAR_NEEDED_ACTIONS';
export const SET_TENANT_USERS = 'SET_TENANT_USERS';
export const CLEAR_TENANT_USERS = 'CLEAR_TENANT_USERS';
export const SET_PENDING_USERS = 'SET_PENDING_USERS';
export const CLEAR_PENDING_USERS = 'CLEAR_PENDING_USERS';
export const SET_TENANT_USERS_LIST_OPTIONS = 'SET_TENANT_USERS_LIST_OPTIONS';
export const SET_IS_SERVICE_PROVIDER = 'SET_IS_SERVICE_PROVIDER';
export const SET_CUSTOMER_PROFILE_DETAILS = 'SET_CUSTOMER_PROFILE_DETAILS';
export const CLEAR_CUSTOMER_PROFILE_DETAILS = 'CLEAR_CUSTOMER_PROFILE_DETAILS';
export const SET_COMPANY_CUSTOMER_PROFILE_DETAILS = 'SET_COMPANY_CUSTOMER_PROFILE_DETAILS';
export const CLEAR_COMPANY_CUSTOMER_PROFILE_DETAILS = 'CLEAR_COMPANY_CUSTOMER_PROFILE_DETAILS';
export const SET_SERVICE_PROVIDER_WORKER_PROFILE = 'SET_SERVICE_PROVIDER_WORKER_PROFILE';
export const CLEAR_SERVICE_PROVIDER_WORKER_PROFILE = 'CLEAR_SERVICE_PROVIDER_WORKER_PROFILE';
export const SET_SERVICE_PROVIDER_COMPANY_PROFILE = 'SET_SERVICE_PROVIDER_COMPANY_PROFILE';
export const CLEAR_SERVICE_PROVIDER_COMPANY_PROFILE = 'CLEAR_SERVICE_PROVIDER_COMPANY_PROFILE';
export const SET_SERVICE_PROVIDER_FREELANCER_PROFILE = 'SET_SERVICE_PROVIDER_FREELANCER_PROFILE';
export const CLEAR_SERVICE_PROVIDER_FREELANCER_PROFILE = 'CLEAR_SERVICE_PROVIDER_FREELANCER_PROFILE';
export const SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS = 'SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS';
export const SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING = 'SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING';
export const SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING_ERRORS = 'SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING_ERRORS';
export const SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS = 'SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS';
export const SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING = 'SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING';
export const SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING_ERRORS = 'SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING_ERRORS';
export const SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS = 'SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS';
export const SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING = 'SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING';
export const SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING_ERRORS = 'SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING_ERRORS';
export const SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS = 'SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS';
export const SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING = 'SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING';
export const SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING_ERRORS = 'SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING_ERRORS';
export const SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS = 'SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS';
export const SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING = 'SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING';
export const SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING_ERRORS = 'SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING_ERRORS';
export const SET_SERVICE_PROVIDERS_OF_COMPANY = 'SET_SERVICE_PROVIDERS_OF_COMPANY';
export const CLEAR_SERVICE_PROVIDERS_OF_COMPANY = 'CLEAR_SERVICE_PROVIDERS_OF_COMPANY';
export const SET_CURRENT_SP_EMPLOYEE = 'SET_CURRENT_SP_EMPLOYEE';
export const SET_SERVICE_PROVIDER_EMPLOYEE_ID = 'SET_SERVICE_PROVIDER_EMPLOYEE_ID';
export const CLEAR_SERVICE_PROVIDER_EMPLOYEE_ID = 'CLEAR_SERVICE_PROVIDER_EMPLOYEE_ID';
export const SET_SP_EMPLOYEE_BEFORE_EDIT = 'SET_SP_EMPLOYEE_BEFORE_EDIT';
export const SET_FEATURES = 'SET_FEATURES';
export const CLEAR_FEATURES = 'CLEAR_FEATURES';
export const SET_LOADING_VALIDATION = 'SET_LOADING_VALIDATION';
export const CLEAR_LOADING_VALIDATION = 'CLEAR_LOADING_VALIDATION';
export const SET_SYSTEM_SETTINGS = 'SET_SYSTEM_SETTINGS';
export const CLEAR_SYSTEM_SETTINGS = 'CLEAR_SYSTEM_SETTINGS';
export const SET_DELETE_USER_LOADING = 'SET_DELETE_USER_LOADING';
export const CLEAR_DELETE_USER_LOADING = 'CLEAR_DELETE_USER_LOADING';
export const SET_USER_DETAILS_FOR_EDIT = 'SET_USER_DETAILS_FOR_EDIT';
export const CLEAR_USER_DETAILS_FOR_EDIT = 'CLEAR_USER_DETAILS_FOR_EDIT';
export const SET_NEW_USER_PASSWORD = 'SET_NEW_USER_PASSWORD';
export const CLEAR_NEW_USER_PASSWORD = 'CLEAR_NEW_USER_PASSWORD';
export const SET_LICENSE_DATA = 'SET_LICENSE_DATA';
